import React from 'react';
import { ShieldCheck, Eye, TrendingUp, CheckCircle2Icon } from 'lucide-react';
export function ImpactSlide() {
  const blocks = [{
    title: 'Public Safety & Security',
    color: '#22C55E',
    icon: <ShieldCheck className="w-6 h-6" data-id="element-244" />,
    points: ['Reduce unsafe driving and accidents', 'Ensure verified driver identity', 'Detect suspicious activities'],
    impacts: ['Safer roads', 'Reduced incidents', 'Higher driver accountability']
  }, {
    title: 'Regulatory Control & Compliance',
    color: '#3B82F6',
    icon: <Eye className="w-6 h-6" data-id="element-245" />,
    points: ['Full real-time visibility', 'Standardized rules across platforms', 'Centralized monitoring'],
    impacts: ['Stronger enforcement', 'Unified regulatory control', 'Faster investigations']
  }, {
    title: 'Economic Transparency & Efficiency',
    color: '#F59E0B',
    icon: <TrendingUp className="w-6 h-6" data-id="element-246" />,
    points: ['Visibility on transactions and delivery volumes', 'Reduce fraud and hidden activities', 'Data-driven insights for authorities'],
    impacts: ['Increased transparency', 'Reduced financial leakage', 'Better policy decisions']
  }];
  return <div className="flex flex-col w-screen h-screen overflow-hidden bg-white text-[#1a1a2e] px-8 py-6" data-id="element-247">
      {/* Top Header */}
      <div className="flex justify-between items-start shrink-0" data-id="element-248">
        <img src="https://cdn.magicpatterns.com/uploads/wGUVVF9ppu2J6VxJ2kpoN3/Pair2_Logo.png" alt="Pair2 Logo" className="h-8 w-auto object-contain" data-id="element-249" />
      </div>

      {/* Title */}
      <div className="text-center shrink-0 mb-6 mt-2" data-id="element-250">
        <span className="text-xs font-semibold text-[#2EBCB0] uppercase tracking-widest" data-id="element-251">
          Why It Matters
        </span>
        <h1 className="text-[1.5rem] font-bold text-[#1a1a2e] mt-1" data-id="element-252">
          National Impact & Value
        </h1>
      </div>

      {/* 3 Horizontal Rows */}
      <div className="flex-grow flex flex-col justify-center gap-5 max-w-7xl mx-auto w-full" data-id="element-253">
        {blocks.map((block, idx) => <div key={idx} className="flex items-stretch bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow duration-300 overflow-hidden" data-id="element-254">
            {/* Left color bar */}
            <div className="w-1.5 shrink-0" style={{
          backgroundColor: block.color
        }} data-id="element-255" />

            {/* Icon + Title */}
            <div className="flex items-center gap-4 px-6 py-5 w-[28%] shrink-0 border-r border-gray-100" data-id="element-256">
              <div className="w-11 h-11 rounded-xl flex items-center justify-center shrink-0" style={{
            backgroundColor: `${block.color}15`,
            color: block.color
          }} data-id="element-257">
                {block.icon}
              </div>
              <h3 className="font-bold text-[0.9rem] text-[#1a1a2e] leading-tight" data-id="element-258">
                {block.title}
              </h3>
            </div>

            {/* Bullet Points */}
            <div className="flex flex-col justify-center gap-2.5 px-6 py-4 flex-1 border-r border-gray-100" data-id="element-259">
              {block.points.map((point, pIdx) => <div key={pIdx} className="flex items-start gap-2.5" data-id="element-260">
                  <div className="w-1.5 h-1.5 rounded-full mt-1.5 shrink-0" style={{
              backgroundColor: block.color
            }} data-id="element-261" />
                  <span className="text-[0.8rem] text-gray-600 leading-snug" data-id="element-262">
                    {point}
                  </span>
                </div>)}
            </div>

            {/* Impact Section */}
            <div className="flex flex-col justify-center gap-2 px-6 py-4 w-[30%] shrink-0" style={{
          backgroundColor: `${block.color}06`
        }} data-id="element-263">
              <h4 className="text-[0.65rem] font-bold uppercase tracking-wider mb-1" style={{
            color: block.color
          }} data-id="element-264">
                Impact
              </h4>
              {block.impacts.map((impact, iIdx) => <div key={iIdx} className="flex items-center gap-2" data-id="element-265">
                  <CheckCircle2Icon className="w-3.5 h-3.5 shrink-0" style={{
              color: block.color
            }} data-id="element-266" />
                  <span className="text-[0.78rem] font-semibold text-[#1a1a2e]" data-id="element-267">
                    {impact}
                  </span>
                </div>)}
            </div>
          </div>)}
      </div>

      {/* Bottom Tagline */}
      <div className="text-center shrink-0 mt-6" data-id="element-268">
        <p className="text-[0.85rem] italic text-gray-500 font-medium" data-id="element-269">
          "Transforming delivery operations into a transparent, controlled, and
          nationally governed ecosystem."
        </p>
      </div>
    </div>;
}